import http from "@/utils/axios";

const USER_CURRENT_WEIGHT = {
  current_bmi: 0,
  current_weight: 0,
  initial_weight: 0,
  target_weight: 0,
  target_weight_unit: "kg",
  total_lost: 0,
  to_reach_target_weight: 0,
  progress_percentage: 0,
};

const WEIGHT_LIST_DATA = {
  data: [],
  pagination: {
    currentPage: 1,
    total: 1,
  },
};

export default {
  namespaced: true,
  state: {
    userCurrentWeight: {
      ...USER_CURRENT_WEIGHT,
    },
    activePlanInfo: null,
    activePlanStatus: null,
    hasArchivePlans: null,
    weightChartData: null,
    weightListData: {
      ...WEIGHT_LIST_DATA,
    },
    weightChartPeriod: "WEEK",

    isLoadingWeightChartData: false,
    isLoadingActivePlan: false,
    isLoadedActivePlan: false,
    isLoadedUserCurrentWeight: false,
    isLoadingWeightListData: false,
  },
  getters: {
    getUserCurrentWeight: (state) => state.userCurrentWeight,
    getActivePlanInfo: (state) => state.activePlanInfo,
    hasArchivePlans: (state) => state.hasArchivePlans,
    getActivePlanStatus: (state) => state.activePlanStatus,
    getWeightChartData: (state) => state.weightChartData,
    getWeightListData: (state) => state.weightListData.data,
    getWeightListDataPagination: (state) => state.weightListData.pagination,
    getWeightChartPeriod: (state) => state.weightChartPeriod,
    isLoadingActivePlan: (state) => state.isLoadingActivePlan,
    isLoadedActivePlan: (state) => state.isLoadedActivePlan,
    isLoadedUserCurrentWeight: (state) => state.isLoadedUserCurrentWeight,
    isLoadingWeightChartData: (state) => state.isLoadingWeightChartData,
    isLoadingWeightListData: (state) => state.isLoadingWeightListData,
  },
  mutations: {
    setUserCurrentWeight(state, userCurrentWeight) {
      state.userCurrentWeight = { ...userCurrentWeight };
    },
    setActivePlanInfo(state, activePlanInfo) {
      state.activePlanInfo = activePlanInfo;
    },
    setActivePlanStatus(state, activePlanStatus) {
      state.activePlanStatus = activePlanStatus;
    },
    setHasArchivePlans(state, hasArchivePlans) {
      state.hasArchivePlans = hasArchivePlans;
    },
    setWeightChartData(state, weightChartData) {
      state.weightChartData = weightChartData;
    },
    setWeightChartPeriod(state, weightChartPeriod) {
      state.weightChartPeriod = weightChartPeriod;
    },
    setWeightListData(state, weightListData) {
      state.weightListData.data = weightListData;
    },
    setWeightListDataPagination(state, weightListDataPagination) {
      state.weightListData.pagination = {
        ...weightListDataPagination,
      };
    },
    setIsLoadingActivePlan(state, isLoadingActivePlan) {
      state.isLoadingActivePlan = isLoadingActivePlan;
    },
    setIsLoadedActivePlan(state, isLoadedActivePlan) {
      state.isLoadedActivePlan = isLoadedActivePlan;
    },
    setIsLoadedUserCurrentWeight(state, isLoadedUserCurrentWeight) {
      state.isLoadedUserCurrentWeight = isLoadedUserCurrentWeight;
    },
    setIsLoadingWeightChartData(state, isLoadingWeightChartData) {
      state.isLoadingWeightChartData = isLoadingWeightChartData;
    },
    setIsLoadingWeighListData(state, isLoadingWeightListData) {
      state.isLoadingWeightListData = isLoadingWeightListData;
    },
    clearWeightChartData(state) {
      state.weightChartData = null;
    },
    clearUserCurrentWeight(state) {
      state.userCurrentWeight = { ...USER_CURRENT_WEIGHT };
    },
    clearWeightListData(state) {
      state.weightListData = { ...WEIGHT_LIST_DATA };
    },
    clearActivePlan(state) {
      state.activePlanInfo = null;
      state.activePlanStatus = null;
      state.hasArchivePlans = null;
      state.isLoadedActivePlan = false;
    },
  },
  actions: {
    async fetchActivePlan({ commit }) {
      commit("setIsLoadingActivePlan", true);
      commit("setIsLoadedActivePlan", false);

      try {
        const { data } = await http.get("/user/weight-loss/active");

        commit("setActivePlanInfo", data.plan_info);
        commit("setActivePlanStatus", data.status);
        commit("setHasArchivePlans", data.has_archive_plans);
        commit("setIsLoadedActivePlan", true);
      } catch (e) {
        commit("clearActivePlan");
      }

      commit("setIsLoadingActivePlan", false);
    },
    async fetchUserCurrentWeight({ commit }) {
      try {
        commit("setIsLoadedUserCurrentWeight", true);

        const { data } = await http.get("/user/weight-loss/current-weight");

        commit("setUserCurrentWeight", data);
      } catch (e) {
        commit("clearUserCurrentWeight");
      }

      commit("setIsLoadedUserCurrentWeight", false);
    },
    async fetchUserWeights({ commit, state }, period = null) {
      if (!period) {
        period = state.weightChartPeriod;
      }

      try {
        commit("setIsLoadingWeightChartData", true);

        const { data } = await http.get("/user/weight-loss/chart-weights", {
          params: {
            period,
          },
        });

        commit("setWeightChartData", data);
      } catch (e) {
        commit("clearWeightChartData");
      }

      commit("setIsLoadingWeightChartData", false);
    },
    async fetchUserWeightsListData({ commit, state }, perPage) {
      try {
        commit("setIsLoadingWeighListData", true);

        const { data } = await http.get("/user/weight-loss/weights", {
          params: {
            per_page: perPage,
            page: state.weightListData.pagination.currentPage,
          },
        });

        commit("setWeightListData", data.data);
        commit("setWeightListDataPagination", {
          currentPage: data.meta.current_page,
          total: data.meta.last_page,
        });
      } catch (e) {
        commit("clearWeightListData");
      }

      commit("setIsLoadingWeighListData", false);
    },
  },
};
